import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fb43e9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "maas-page" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<section class=\"hero-section\" data-v-3fb43e9c><div class=\"hero-container\" data-v-3fb43e9c><div class=\"hero-bg-decoration hero-bg-right\" data-v-3fb43e9c></div><div class=\"hero-bg-decoration hero-bg-left\" data-v-3fb43e9c></div><div class=\"hero-content\" data-v-3fb43e9c><div class=\"hero-text\" data-v-3fb43e9c><h1 class=\"hero-title\" data-v-3fb43e9c> 白海 <span class=\"hero-title-highlight\" data-v-3fb43e9c>AI Gallery</span></h1><p class=\"hero-description\" data-v-3fb43e9c> 企业级 AI 资产中心。一站式获取高性能预训练模型，支持模型在线部署、测试与微调；灵活调用模型API 服务，底层算力无感支撑。 </p></div><div class=\"hero-illustration\" data-v-3fb43e9c><div class=\"scene-container\" data-v-3fb43e9c><div class=\"isometric-group animate-float-group\" data-v-3fb43e9c><div class=\"iso-layer layer-base\" data-v-3fb43e9c><div class=\"grid-pattern\" data-v-3fb43e9c></div><div class=\"chip-icon\" data-v-3fb43e9c><i class=\"fas fa-microchip\" data-v-3fb43e9c></i></div><div class=\"infrastructure-label\" data-v-3fb43e9c>INFRASTRUCTURE</div></div><div class=\"connector\" data-v-3fb43e9c></div><div class=\"iso-layer layer-mid\" data-v-3fb43e9c><div class=\"model-gallery-content\" data-v-3fb43e9c><div class=\"model-gallery-header\" data-v-3fb43e9c><div class=\"control-dot control-dot-red\" data-v-3fb43e9c></div><div class=\"control-dot control-dot-yellow\" data-v-3fb43e9c></div><div class=\"control-bar\" data-v-3fb43e9c></div></div><div class=\"model-cards-grid\" data-v-3fb43e9c><div class=\"model-card model-card-blue\" data-v-3fb43e9c><div class=\"model-card-icon model-card-icon-blue\" data-v-3fb43e9c><i class=\"fas fa-cube\" data-v-3fb43e9c></i></div><div class=\"model-card-title\" data-v-3fb43e9c></div><div class=\"model-card-subtitle\" data-v-3fb43e9c></div></div><div class=\"model-card model-card-purple\" data-v-3fb43e9c><div class=\"model-card-icon model-card-icon-purple\" data-v-3fb43e9c><i class=\"fas fa-image\" data-v-3fb43e9c></i></div><div class=\"model-card-title\" data-v-3fb43e9c></div><div class=\"model-card-subtitle\" data-v-3fb43e9c></div></div></div><div class=\"model-market-label\" data-v-3fb43e9c>MODEL MARKET</div></div></div><div class=\"particle particle-1\" data-v-3fb43e9c></div><div class=\"particle particle-2\" data-v-3fb43e9c></div><div class=\"iso-layer layer-top\" data-v-3fb43e9c><div class=\"maas-content\" data-v-3fb43e9c><div class=\"cloud-icon-wrapper\" data-v-3fb43e9c><i class=\"fas fa-cloud\" data-v-3fb43e9c></i></div><div class=\"maas-label\" data-v-3fb43e9c>MaaS API</div></div></div><div class=\"floating-cloud\" data-v-3fb43e9c></div></div><div class=\"bottom-shadow\" data-v-3fb43e9c></div></div></div></div></div></section>", 1)
const _hoisted_3 = {
  id: "model-market",
  class: "model-market-section"
}
const _hoisted_4 = { class: "container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "model-market-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "section-tag" }, " 模型市场 "),
  /*#__PURE__*/_createElementVNode("p", { class: "section-title" }, "海量预训练模型"),
  /*#__PURE__*/_createElementVNode("p", { class: "section-description" }, " 汇聚全球顶尖开源模型与白海优选模型，包括大语言模型 (LLM)、多模态大模型及各类垂直领域模型；支持模型的在线测试、部署与零代码微调。 ")
], -1))
const _hoisted_6 = { class: "category-tags" }
const _hoisted_7 = { class: "tag-button tag-button-active" }
const _hoisted_8 = { class: "tag-button tag-button-blue" }
const _hoisted_9 = { class: "tag-button tag-button-purple" }
const _hoisted_10 = { class: "tag-button tag-button-green" }
const _hoisted_11 = { class: "tag-button tag-button-orange" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tag-more" }, "...", -1))
const _hoisted_13 = { class: "model-cards-container" }
const _hoisted_14 = { class: "model-card-item" }
const _hoisted_15 = { class: "model-card-header" }
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"model-info\" data-v-3fb43e9c><div class=\"model-avatar model-avatar-blue\" data-v-3fb43e9c>D</div><div class=\"model-details\" data-v-3fb43e9c><h3 class=\"model-name\" data-v-3fb43e9c>DeepSeek V3</h3><span class=\"model-meta\" data-v-3fb43e9c>DeepSeek • 更新于3个月前</span></div></div>", 1)
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<p class=\"model-description\" data-v-3fb43e9c> 最强开源 MoE 模型，在数学、代码和推理任务上表现卓越，媲美顶尖闭源模型。 </p><div class=\"model-tags\" data-v-3fb43e9c><span class=\"model-tag model-tag-gray\" data-v-3fb43e9c>NLP</span><span class=\"model-tag model-tag-gray\" data-v-3fb43e9c>MoE</span><span class=\"model-tag model-tag-yellow\" data-v-3fb43e9c>Hot</span></div>", 2)
const _hoisted_19 = { class: "model-card-item" }
const _hoisted_20 = { class: "model-card-header" }
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"model-info\" data-v-3fb43e9c><div class=\"model-avatar model-avatar-purple\" data-v-3fb43e9c>Q</div><div class=\"model-details\" data-v-3fb43e9c><h3 class=\"model-name\" data-v-3fb43e9c>Qwen-3-32B-Instruct</h3><span class=\"model-meta\" data-v-3fb43e9c>阿里云 • 更新于1 个月前</span></div></div>", 1)
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "model-description" }, " 通义千问最新一代中型参数模型，在性能与推理速度之间实现了完美平衡，适合商业应用。 ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "model-tags" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "model-tag model-tag-gray" }, "NLP"),
  /*#__PURE__*/_createElementVNode("span", { class: "model-tag model-tag-gray" }, "通用助手")
], -1))
const _hoisted_24 = { class: "model-card-item" }
const _hoisted_25 = { class: "model-card-header" }
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<div class=\"model-info\" data-v-3fb43e9c><div class=\"model-avatar model-avatar-orange\" data-v-3fb43e9c>M</div><div class=\"model-details\" data-v-3fb43e9c><h3 class=\"model-name\" data-v-3fb43e9c>Minimax-M2</h3><span class=\"model-meta\" data-v-3fb43e9c>MiniMax • 更新于 3 周前</span></div></div>", 1)
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "model-description" }, " 拥有超长上下文处理能力的混合专家模型，在逻辑推理和角色扮演场景中表现优异。 ", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "model-tags" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "model-tag model-tag-gray" }, "NLP"),
  /*#__PURE__*/_createElementVNode("span", { class: "model-tag model-tag-gray" }, "超长上下文")
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "view-all-models" }, [
  /*#__PURE__*/_createElementVNode("span", {
    href: "#",
    class: "view-all-link"
  }, [
    /*#__PURE__*/_createTextVNode(" 全部 5,000+ 模型 "),
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-right view-all-arrow" })
  ])
], -1))
const _hoisted_30 = {
  id: "maas-market",
  class: "maas-market-section"
}
const _hoisted_31 = { class: "container maas-container" }
const _hoisted_32 = { class: "maas-content-layout" }
const _hoisted_33 = { class: "maas-value-proposition" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-tag" }, " 模型服务市场 ", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "maas-title" }, [
  /*#__PURE__*/_createTextVNode(" 模型服务市场 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "maas-title-highlight" }, "连接调用者与开发者")
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "maas-description" }, " 提供企业级高并发 API 服务。不仅可以调用主流模型，更支持用户将私有模型发布为公共 API，构建 AI 创作者经济。 ", -1))
const _hoisted_37 = { class: "features-list" }
const _hoisted_38 = { class: "feature-item" }
const _hoisted_39 = { class: "feature-icon feature-icon-blue" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "feature-content" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "feature-title" }, "主流模型立即使用"),
  /*#__PURE__*/_createElementVNode("p", { class: "feature-description" }, "无需部署 GPU，直接通过 API 调用主流 LLM、多模态模型、深度学习小模型等服务。")
], -1))
const _hoisted_41 = { class: "feature-item" }
const _hoisted_42 = { class: "feature-icon feature-icon-purple" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "feature-content" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "feature-title" }, "发布您的 API 服务"),
  /*#__PURE__*/_createElementVNode("p", { class: "feature-description" }, "将您微调的模型一键发布到市场。设置定价策略，供其他开发者调用，赚取收益。")
], -1))
const _hoisted_44 = { class: "maas-architecture" }
const _hoisted_45 = { class: "schematic-box" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "schematic-bg-grid" }, null, -1))
const _hoisted_47 = { class: "schematic-content" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "client-layer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "api-label" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "api-line" }),
    /*#__PURE__*/_createElementVNode("div", { class: "api-text" }, "RESTFUL API")
  ])
], -1))
const _hoisted_49 = { class: "arrow-down animation" }
const _hoisted_50 = { class: "maas-platform-box" }
const _hoisted_51 = /*#__PURE__*/_createStaticVNode("<div class=\"platform-header\" data-v-3fb43e9c><span class=\"platform-title\" data-v-3fb43e9c>模型服务市场</span><div class=\"platform-status\" data-v-3fb43e9c><div class=\"status-dot status-dot-green\" data-v-3fb43e9c></div><div class=\"status-dot status-dot-blue\" data-v-3fb43e9c></div></div></div>", 1)
const _hoisted_52 = { class: "platform-content" }
const _hoisted_53 = { class: "services-grid" }
const _hoisted_54 = { class: "service-item" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "service-label" }, "安全认证", -1))
const _hoisted_56 = { class: "service-item" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "service-label" }, "负载均衡", -1))
const _hoisted_58 = { class: "service-item" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "service-label" }, "计费系统", -1))
const _hoisted_60 = { class: "model-engine" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "engine-title" }, "推理引擎", -1))
const _hoisted_62 = { class: "models-grid" }
const _hoisted_63 = /*#__PURE__*/_createStaticVNode("<div class=\"model-engine-item\" data-v-3fb43e9c><span class=\"model-engine-dot model-engine-dot-blue\" data-v-3fb43e9c></span><span class=\"model-engine-name\" data-v-3fb43e9c>Qwen</span></div><div class=\"model-engine-item\" data-v-3fb43e9c><span class=\"model-engine-dot model-engine-dot-teal\" data-v-3fb43e9c></span><span class=\"model-engine-name\" data-v-3fb43e9c>GLM</span></div><div class=\"model-engine-item\" data-v-3fb43e9c><span class=\"model-engine-dot model-engine-dot-orange\" data-v-3fb43e9c></span><span class=\"model-engine-name\" data-v-3fb43e9c>MiniMax</span></div><div class=\"model-engine-item\" data-v-3fb43e9c><span class=\"model-engine-dot model-engine-dot-purple\" data-v-3fb43e9c></span><span class=\"model-engine-name\" data-v-3fb43e9c>SDXL</span></div><div class=\"model-engine-item model-engine-item-more\" data-v-3fb43e9c><span class=\"model-engine-more\" data-v-3fb43e9c>...</span></div>", 5)
const _hoisted_68 = { class: "model-engine-item model-engine-item-user" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "user-model-name" }, "您的模型", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", _hoisted_7, [
            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-layer-group tag-icon" }),
            _createTextVNode(" 全部模型 ")
          ]),
          _createElementVNode("button", _hoisted_8, [
            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-comment-dots tag-icon" }),
            _createTextVNode(" LLM / 文本生成 ")
          ]),
          _createElementVNode("button", _hoisted_9, [
            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-image tag-icon" }),
            _createTextVNode(" 多模态 / AIGC ")
          ]),
          _createElementVNode("button", _hoisted_10, [
            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-eye tag-icon" }),
            _createTextVNode(" 计算机视觉 ")
          ]),
          _createElementVNode("button", _hoisted_11, [
            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-wave-square tag-icon" }),
            _createTextVNode(" 语音 / ASR ")
          ]),
          _hoisted_12
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_font_awesome_icon, { icon: "fa-regular fa-star model-star" })
            ]),
            _hoisted_17
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createVNode(_component_font_awesome_icon, { icon: "fa-regular fa-star model-star" })
            ]),
            _hoisted_22,
            _hoisted_23
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode(_component_font_awesome_icon, { icon: "fa-regular fa-star model-star" })
            ]),
            _hoisted_27,
            _hoisted_28
          ])
        ]),
        _hoisted_29
      ])
    ]),
    _createElementVNode("section", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _hoisted_35,
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(_component_font_awesome_icon, { icon: "fas fa-bolt" })
                ]),
                _hoisted_40
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(_component_font_awesome_icon, { icon: "fas fa-store" })
                ]),
                _hoisted_43
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _hoisted_46,
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _createElementVNode("div", _hoisted_49, [
                  _createVNode(_component_font_awesome_icon, {
                    style: {"color":"blue"},
                    icon: "fas fa-arrow-up"
                  })
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _hoisted_51,
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("div", _hoisted_54, [
                        _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-shield-halved service-icon" }),
                        _hoisted_55
                      ]),
                      _createElementVNode("div", _hoisted_56, [
                        _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-scale-balanced service-icon" }),
                        _hoisted_57
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-file-invoice-dollar service-icon" }),
                        _hoisted_59
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _hoisted_61,
                      _createElementVNode("div", _hoisted_62, [
                        _hoisted_63,
                        _createElementVNode("div", _hoisted_68, [
                          _createVNode(_component_font_awesome_icon, {
                            style: {"font-size":"11px"},
                            icon: "fa-solid fa-user-gear user-model-icon"
                          }),
                          _hoisted_69
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}